import { loadToken } from "./storage";
import { IAdvisorErrorResponse } from "@types";

/**
 * The advisor backend doesn't use Django's {success, data, message} envelope, and it
 * reports errors via HTTP status + {error: {code, message}} instead of a `success` field —
 * tomService's "success unless success===false" check would silently miss that. This reuses
 * the same token handling as tomService but checks res.ok directly instead.
 */

interface IAdvisorServiceArgs {
  url: string;
  method: string;
  body?: any;
}

export const advisorService =
  ({ baseUrl } = { baseUrl: "" }) =>
  async ({ url, method, body }: IAdvisorServiceArgs) => {
    const headers: Record<string, string> = { Accept: "application/json" };
    const accessToken = loadToken();

    if (accessToken) {
      headers["Authorization"] = `Bearer ${accessToken}`;
    }

    const reqBody: {
      method: string;
      headers: Record<string, string>;
      body?: string;
    } = { method, headers };

    if (body !== undefined) {
      headers["Content-Type"] = "application/json";
      reqBody.body = JSON.stringify(body);
    }

    try {
      const res = await fetch(`${baseUrl}${url}`, reqBody);
      const json = await res.json();

      if (!res.ok) {
        const error = json?.error ?? {};
        return {
          error: {
            status: res.status,
            code: error.code || "ADVISOR_ERROR",
            message: error.message || "Something went wrong. Please try again.",
            correlation_id: error.correlation_id,
          } as IAdvisorErrorResponse,
        };
      }

      return { data: json };
    } catch (error: any) {
      return {
        error: {
          status: "FETCH_ERROR",
          code: "ADVISOR_ERROR",
          message: error?.message || "Something went wrong. Please try again.",
        } as IAdvisorErrorResponse,
      };
    }
  };
